import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/** @jsx jsx */
import React, { useMemo } from 'react';
import { jsx } from '@emotion/core';
import { usePlatformLeafEventHandler } from '@atlaskit/analytics-next';
import { getStyles } from '../internal/styles';
import { name as packageName, version as packageVersion } from '../version.json';
import EllipsisItem from './EllipsisItem';
var defaultMaxItems = 8;
var toArray = React.Children.toArray;
var analyticsAttributes = {
  componentName: 'breadcrumbs',
  packageName: packageName,
  packageVersion: packageVersion
};

var noop = function noop() {};

var BreadcrumbsStateless = function BreadcrumbsStateless(props) {
  var _props$isExpanded = props.isExpanded,
      isExpanded = _props$isExpanded === void 0 ? false : _props$isExpanded,
      _props$maxItems = props.maxItems,
      maxItems = _props$maxItems === void 0 ? defaultMaxItems : _props$maxItems,
      _props$itemsBeforeCol = props.itemsBeforeCollapse,
      itemsBeforeCollapse = _props$itemsBeforeCol === void 0 ? 1 : _props$itemsBeforeCol,
      _props$itemsAfterColl = props.itemsAfterCollapse,
      itemsAfterCollapse = _props$itemsAfterColl === void 0 ? 1 : _props$itemsAfterColl,
      _props$mode = props.mode,
      mode = _props$mode === void 0 ? 'light' : _props$mode,
      _props$children = props.children,
      children = _props$children === void 0 ? [] : _props$children,
      testId = props.testId,
      _props$onExpand = props.onExpand,
      onExpandProvided = _props$onExpand === void 0 ? noop : _props$onExpand,
      analyticsContext = props.analyticsContext;
  var handleExpand = usePlatformLeafEventHandler(_objectSpread({
    fn: onExpandProvided,
    action: 'expanded',
    analyticsData: analyticsContext
  }, analyticsAttributes));

  var renderAllItems = function renderAllItems() {
    var allNonEmptyItems = toArray(children);
    return allNonEmptyItems.map(function (child, index) {
      return /*#__PURE__*/React.cloneElement(child, {
        hasSeparator: index < allNonEmptyItems.length - 1
      });
    });
  };

  var renderItemsBeforeAndAfter = function renderItemsBeforeAndAfter() {
    // Not a chance this will trigger, but TS is complaining about items* possibly being undefined.
    if (itemsBeforeCollapse === undefined || itemsAfterCollapse === undefined) {
      return;
    }

    var allItems = renderAllItems(); // This defends against someone passing weird data, to ensure that if all
    // items would be shown anyway, we just show all items without the EllipsisItem

    if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
      return allItems;
    }

    var beforeItems = allItems.slice(0, itemsBeforeCollapse);
    var afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
    return [].concat(_toConsumableArray(beforeItems), [jsx(EllipsisItem, {
      hasSeparator: itemsAfterCollapse > 0,
      key: "ellipsis",
      testId: testId && "".concat(testId, "--breadcrumb-ellipsis"),
      onClick: handleExpand
    })], _toConsumableArray(afterItems));
  };

  var breadcrumbStyles = useMemo(function () {
    return getStyles(mode);
  }, [mode]);
  return jsx("div", {
    "data-testid": testId,
    css: breadcrumbStyles
  }, isExpanded || maxItems && toArray(children).length <= maxItems ? renderAllItems() : renderItemsBeforeAndAfter());
};

export default BreadcrumbsStateless;